import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

function CoachesList({ coach, showArrow }) {
  return (
    <div className="p-2 md:p-3 mb-4 bg-white border border-red-500 rounded-lg shadow flex items-center">
      <div className="flex space-x-4">
        <div className="h-[40px] w-[40px] overflow-hidden rounded-md">
          <img
            alt={coach.name}
            src={coach.profilePicture || "/default-profile-img.png"}
            className="h-full w-full object-cover"
          />
        </div>
        <div className="overflow-hidden max-w-[200px]">
          <h2 className="text-base lg:text-lg uppercase truncate ">
            {coach.name} {coach.lastname}
          </h2>
          <p className="text-sm text-gray-700 break-words">
            {coach.university}
          </p>
        </div>
      </div>
      {showArrow && (
        <div className="ml-auto text-black">
          <FontAwesomeIcon
            icon={faChevronRight}
            className="text-2xl font-bold"
          />
        </div>
      )}
    </div>
  );
}

export default CoachesList;
